module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--5-65be27f30dc1f3b1c93071e5e55e8b1a.jpg";